import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import _ from 'lodash';
import colorTheme from '../../../utils/color-theme';
import { RegularButton } from '../../button';
import ScaledText from '../../scaled-text';
import { COLORS } from 'src/theme';

const fontFamily = 'Lato, sans-serif';

const defaultStyles = StyleSheet({
  topBanner: {
    border: 'solid 1px darkgray',
    overflow: 'hidden',
    flexGrow: 0,
    flexShrink: 0
  },
  shortHeadline: {
    fontSize: '30px',
    lineHeight: '38px',
    fontWeight: '300',
    fontFamily,
    marginBottom: '20px',
    maxWidth: '290px'
  },
  img: {
    objectFit: 'cover'
  },
  content: {
    backgroundColor: 'white'
  },
  logoWrapper: {},
  footerLogo: {
    maxWidth: 'calc(0.75 * 155px)',
    maxHeight: 'calc(0.4 * 180px)',
    objectFit: 'contain'
  }
});

const buttonStyles = StyleSheet({
  button: {
    width: '146px'
  }
});

@styled(defaultStyles)
class TopBanner extends PureComponent {
  static propTypes = {
    brandColor: PropTypes.string,
    shortHeadline: PropTypes.string,
    primaryImageUrls: PropTypes.object,
    logoUrls: PropTypes.object
  };

  render() {
    const {
      brandColor,
      backgroundColor,
      shortHeadline,
      primaryImageUrls,
      logoUrls,
      styles: s
    } = this.props;

    const { brandColorBorder } = colorTheme(brandColor);

    return (
      <Box width={930} height={180} flexDirection='row' {...s('topBanner')}>
        <Box>
          <img
            width={280}
            height={181}
            src={_.get(primaryImageUrls, ['crop.landscape', 'url'])}
            {...s('img')}
          />
        </Box>
        <Box
          flex={1}
          flexDirection='column'
          justifyContent='center'
          alignItems='flex-start'
          padding='0px 20px'
          {...s('content')}
        >
          <ScaledText
            maxWidth={440}
            maxTextLines={2}
            maxFontSize={34}
            minFontSize={20}
            {...s.with('shortHeadline')({ color: COLORS.BLACK })}
          >
            {shortHeadline}
          </ScaledText>
          <RegularButton brandColor={brandColor} styles={buttonStyles}>
            Find out now
          </RegularButton>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          padding='70px 0'
          width={160}
          {...s.with('logoWrapper')({
            backgroundColor: backgroundColor,
            borderLeft: brandColorBorder
          })}
        >
          <img src={_.get(logoUrls, 'original.url')} {...s('footerLogo')} />
        </Box>
      </Box>
    );
  }
}

export default TopBanner;
